<template>
  <div class="bill-table">
    <el-table :data="data">
      <el-table-column label="账单金额" align="center" prop="devices"></el-table-column>
      <el-table-column label="计费设备总数" align="center" prop="devices"></el-table-column>
      <el-table-column label="账期" align="center">
        <template slot-scope="scope">
          <p v-if="scope.row.day > 0">
         <span v-if="scope.row.month > 0">
            {{date.getFullYear()}}-{{scope.row.month| filterDay}} -{{scope.row.day | filterDay}}
         </span>
            <span v-else>
             {{date.getFullYear()}}-{{(date.getMonth() + 1)| filterDay}}-{{scope.row.day | filterDay}}
          </span>
          </p>
          <span v-else>
         <span v-if="scope.row.month > 0">
            {{date.getFullYear()}}-{{scope.row.month| filterDay}}
         </span>
          <span v-else>
            {{date.getFullYear()}}-{{(date.getMonth() + 1)| filterDay}}
          </span>
        </span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('cao_zuo')" align="center" prop="name">
        <template slot-scope="scope">
          <span @click="handleDetail(scope.row)" class="bill-detail">查看详情</span>
        </template>
      </el-table-column>

    </el-table>

    <c-dialog class="dialog" :visible.sync="feeDetailVisible" :width="'50rem'" :height="'37.5rem'"
              :outer-close="false"
              title="计费详单">
      <div class="delivery-allocated-device-data-list">
        <el-table :data="bills"
                  max-height="320px">
          <el-table-column :label="$t('she_bei_bian_hao')" align="center" prop="deviceUuid"></el-table-column>
          <el-table-column :label="$t('she_bei_ming_cheng')" align="center" prop="deviceName"></el-table-column>
          <el-table-column label="账期" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.month | filterDay}}-{{scope.row.day | filterDay}}</span>
            </template>
          </el-table-column>
          <el-table-column label="计费时间" align="center">
            <template slot-scope="scope">
              <span>{{new Date(scope.row.createdAt * 1000).Format('yyyy-MM-dd')}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @current-change="handleCurrentChange"
        class="pagination"
        :current-page="pagination.curPage"
        :page-size="pagination.limit"
        layout="total, prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>

    </c-dialog>
  </div>

</template>

<script>
  import CDialog from '@/components/Dialog'

  import {billDailyUnion, billDailyList} from '@/api/factory/bill'

  export default {
    name: '',
    components: {
      CDialog
    },
    props: {
      data: {
        type: Array,
        default: function () {
          return []
        }
      },
      date: {
        type: Date,
        default: function () {
          return new Date()
        }
      }
    },
    filters: {
      filterDay(data) {
        if (data < 10) {
          return '0' + data
        }
        return data
      }
    },
    mounted: function () {
    },
    data: function () {
      return {
        feeDetailVisible: false,
        bills: [],
        pagination: {
          year: this.date.getFullYear(),
          month: 0,
          day: 0,
          start: 0,
          curPage: 1,
          limit: 8,
          total: 0,
        },
      }
    },
    methods: {
      handleCurrentChange(value) {
        this.pagination.curPage = value
        this.pagination.start = (value - 1) * this.pagination.limit
        billDailyList(this.pagination).then(res => {
          this.bills = res.data || []

        })
      },
      handleDetail(value) {
        if (value.year > 0) {
          this.pagination.year = value.year
        } else {
          this.pagination.year = this.date.getFullYear()
        }
        if (value.month > 0) {
          this.pagination.month = value.month
        } else {
          this.pagination.month = this.date.getMonth() + 1
        }
        this.pagination.day = value.day
        let vue = this
        billDailyUnion(this.pagination).then(res => {
          vue.bills = res.data.list || []
          vue.pagination.total = parseInt(res.data.total)
          vue.feeDetailVisible = true
        })
      },

    },
  }
</script>

<style lang="scss">
  .bill-table {
    min-height: 20rem;

    tr {
      background-color: transparent;

      th {
        background-color: transparent;

        .cell {
          color: $f_th_color;
        }
      }

      th.is-leaf {
        border-color: $border_th_color;
      }
    }

    * {
      color: $f_th_color;
      font-size: $table-body-font-size;
    }

    .el-table__row:hover {
      background-color: $bg_sec_color;
    }

    .bill-detail {
      cursor: pointer;
      color: $f_color;
    }


  }

  .bill-table::before, .el-table--group::after, .el-table--border::after {
    background-color: transparent;
  }
</style>
